import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiClient } from '../../core/api-client.service';
import { DumbCompanyDetails } from './DTOs/dumb-company';
import { DumbCompanyAddress } from './DTOs/dumb-company-address';
import { DumbLiaison } from './DTOs/dumb-liaison';
import { UpdatePaymentInfoRequest } from './DTOs/update-payment-info-request';

@Injectable({
  providedIn: 'root'
})
export class MembershipManagementService {
  readonly relativeBase = "member-admin-management/";

  constructor(private http: ApiClient) {

  }
  getCompanyDetails(): Observable<DumbCompanyDetails> {
    return this.http.get(this.relativeBase + "get-company-details");
  }

    
  UpdateCompanyLiaison(request: DumbLiaison) {
    return this.http.post(this.relativeBase + "update-liaison", request);
  }
  UpdateCompanyDetails(request: DumbCompanyDetails) {
    return this.http.post(this.relativeBase + "update-company-details", request);
  }
  AddUpdateCompanyAddress(request: DumbCompanyAddress, adding: boolean) {
    return this.http.post(this.relativeBase + "update-address/" + adding, request);
  }
  UpdateCompanyPaymentInfo(request: UpdatePaymentInfoRequest) {
    return this.http.post(this.relativeBase + "update-company-payment-details", request);
    }
    uploadLogoFile(formData: FormData) {
        return this.http.post(this.relativeBase + "upload-logo", formData);
    }
    UpdateCompanyDirectoryDetails(request: DumbCompanyDetails) {
        return this.http.post(this.relativeBase + "update-directory-details", request);
    }
}
